import { MessageBox } from "element-ui";
/**
 * 确认弹出框
 * created by jiabo.zhang
 */
export const prompt = async function (opts: any = {}) {
  const title = this.$t("Basic.Warning");
  const confirmButtonText = this.$t("Basic.Ok");
  const cancelButtonText = this.$t("Basic.cancel");

  const promptOpts = Object.assign(
    {
      title,
      tips: "",
      showConfirmButton: true,
      showCancelButton: true,
      showInput: opts.message === undefined,
      confirmButtonText,
      cancelButtonText,
      customClass: opts.warn
        ? "el-message-box-reset warn"
        : "el-message-box-reset"
    },
    opts
  );

  return await MessageBox[promptOpts.showInput ? "prompt" : "confirm"](
    promptOpts.tips,
    promptOpts.title,
    promptOpts
  );
};

// is Null
export const isNull = target =>
  Object.prototype.toString.call(target) === "[object Null]";

// 有小数点的情况下使用本方法格式化 money
export const moneyFormat = (num: any = 0) => {
  num += "";
  if (!num.includes(".")) {
    num += ".";
  }
  return num
    .replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => `${$1},`)
    .replace(/\.$/, "");
};
// 一个通用的mutation方法
export const easyMutate = (state, { path, data }) => {
  if (!path) {
    throw new Error("need path");
  }
  const keyPath = path.split(".");
  let needSave = state;
  for (let i = 0; i < keyPath.length - 1; i++) {
    needSave = needSave[keyPath[i]];
    if (!needSave) {
      throw new Error(`error path: ${keyPath[i]}`);
    }
  }

  needSave[keyPath[keyPath.length - 1]] = data;
};

// isObject
export const isObject = target => {
  return Object.prototype.toString.call(target) === "[object Object]";
};

// 解构graphql返回的数据结构
export const resRest = (
  data,
  { path = "api.dataList", node = "node" } = {}
) => {
  const pathStep = path.split("."); // => ['api','dataList']
  let cache = data;

  for (let i = 0; i < pathStep.length; i++) {
    const key = pathStep[i];

    if (cache[key]) {
      cache = cache[key];
    } else {
      throw new Error("Error path.");
    }
  }

  // 这里已经根据key-path找到了 list节点
  // 需要判断一下cache 是否为Array;
  if (!Array.isArray(cache)) {
    throw new Error("Bad required data.");
  }

  return !node
    ? cache
    : cache.map(item => {
        let content = item[node];

        if (!isObject(content)) {
          throw new Error("Bad required node");
        }

        return {
          ...content
        };
      });
};

/**
 * 将一组16位数字字符串 分割为 4位一组
 * splitGroupTo4
 *
 * [ return ] 四位数字为一个成员的数组
 *
 */
export const splitGroupTo4 = (str = "") => str.match(/(\d{1,4})/g);

/**
 * 将类似于 "2020-01-09 00:00:00" 格式的字符串转为 20200109000000
 * councatDataformat
 *
 * [ return ]  年月日时分秒  YYYYMMDDhhmmss
 *
 */
export const councatDataformat = str => {
  // eslint-disable-next-line no-useless-escape
  return str.replace(/\-|\:|\s/g, "");
};

/**
 * 获得两时间戳相减的天数
 * getNumberOfDays
 *
 * date2-endtime   date1-starttime
 * [ return ]  days
 *
 */
export const getNumberOfDays = (date1: any = "", date2: any = "") => {
  let datetime: number = date2 - date1;
  let days = ((datetime / 1000) * 60 * 60 * 24) / (1000 * 60 * 60 * 24);
  return days;
};

/**
 * 获得当前时间的时间YYYYMMDDhhmmss格式
 * getNowYYYYMMDDhhmmss
 *
 * [ return ]  NowYYYYMMDDhhmmss
 *
 */
export const getNowYYYYMMDDhhmmss = () => {
  let pad2 = n => {
    return n < 10 ? "0" + n : n;
  };
  let date = new Date();
  return (
    date.getFullYear().toString() +
    pad2(date.getMonth() + 1) +
    pad2(date.getDate()) +
    pad2(date.getHours()) +
    pad2(date.getMinutes()) +
    pad2(date.getSeconds())
  );
};

/**
 * 等待一段时间
 * sleep
 */
export const sleep = (delay = 1000) => {
  return new Promise(function (resolve, reject) {
    setTimeout(() => {
      resolve(null);
    }, delay);
  });
};

export function operationTransfer(opList = [], neededList = []) {
  // const operationList = opList instanceof Array ? opList : [];

  // function transfer(list = []) {
  //   const defaultOperationMap = {
  //     21: "confirm", // "Confirm order"
  //     31: "pay", // "Pay order"
  //     41: "ready2ship", // "Ready to ship for order/Ship order"
  //     42: "shipped", // "Ship order"
  //     51: "complete", // "Complete order"
  //     61: "cancel" // "Cancel order"
  //   };
  //   const controlMap = {};

  //   list.forEach(id => (controlMap[defaultOperationMap[id]] = true));

  //   return controlMap;
  // }

  // return {
  //   visible: !!operationList.length,
  //   control: transfer(operationList)
  // };

  //     21: "confirm", // "Confirm order"
  //     31: "pay", // "Pay order"
  //     41: "ready2ship", // "Ready to ship for order/Ship order"
  //     42: "shipped", // "Ship order"
  //     51: "complete", // "Complete order"
  //     61: "cancel" // "Cancel order"

  function toMap(list = []) {
    const map = {};

    list.forEach(v => (map[v] = true));

    return map;
  }

  function vaildate(origin = [], all = []) {
    const res = [];

    origin.forEach(v => all.indexOf(v) >= 0 && res.push(v));

    return res;
  }

  return {
    controls: toMap(opList),
    visible: !!(neededList.length ? vaildate(opList, neededList) : opList)
      .length
  };
}

export function setColumnWidth(str) {
  let columnWidth = 0;
  for (let char of str) {
    if ((char >= "A" && char <= "Z") || (char >= "a" && char <= "z")) {
      // 如果是英文字符，为字符分配10个单位宽度，单位宽度可根据字体大小调整
      columnWidth += 10;
    } else if (char >= "\u4e00" && char <= "\u9fa5") {
      // 如果是中文字符，为字符分配14个单位宽度，单位宽度可根据字体大小调整
      columnWidth += 14;
    } else {
      // 其他种类字符，为字符分配10个单位宽度，单位宽度可根据字体大小调整
      columnWidth += 10;
    }
  }
  if (columnWidth < 120) {
    // 设置最小宽度
    columnWidth = 120;
  }
  return columnWidth + "px";
}

export const filterNodeData = (dataList = [], key = "node") => {
  return dataList.map(item => item[key]);
};

// ts 中翻译
export function i18nTs(str) {
  return (window["vm"].$i18n && window["vm"].$i18n.t(`${str}`)) || "";
}

// 将数据转为map
export const expandArrayToMap = (
  list,
  { labelKey = "label", valueKey = "value" } = {}
) => {
  const result = {};
  list.forEach(item => {
    const value = item[valueKey];
    const label = item[labelKey];

    // value有可能是以逗号连接的多个值的组合
    if (value.indexOf(",") > -1) {
      value.split(",").forEach(key => (result[key] = label));
    } else {
      result[value] = label;
    }
  });

  return result;
};

export const obj2Arr = (obj, { key = "label", value = "value" } = {}) => {
  return (
    obj &&
    Object.keys(obj).map(item => {
      return {
        [key]: obj[item],
        [value]: item
      };
    })
  );
};
